import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetothanecab() {



const cardData = {
  keyword: "Pune to Thane Cab",
  heading: "Lotus Cab: Pune to Thane Cab",

  headingDescription:
    "Lotus Cab offers reliable and comfortable Pune to Thane Cab services designed for smooth intercity travel. Whether you are planning a business visit, family trip, airport transfer, or personal journey, our well-maintained sedan and SUV vehicles ensure a safe and relaxing ride. Our professional chauffeurs are experienced in highway driving and familiar with the Mumbai-Pune Expressway route. We provide transparent per-km pricing with one-way and round-trip options available. With punctual pickup anywhere in Pune and 24/7 customer support, we make your Pune to Thane taxi service convenient, affordable, and completely stress-free.",

  top: "Top Places to Visit in Thane with Lotus Cab",

  topPlaces: [
    {
      title: "Upvan Lake",
      description:
        "Upvan Lake is one of the most peaceful and scenic attractions in Thane. Surrounded by lush greenery and Yeoor Hills, it is ideal for morning walks and evening relaxation. Families often visit for picnics and photography. The calm waters create a refreshing atmosphere. It is a must-visit spot during your Thane trip. Perfect destination after a comfortable cab journey."
    },
    {
      title: "Yeoor Hills",
      description:
        "Yeoor Hills offers a refreshing escape from city life. Known for its greenery and fresh air, it attracts nature lovers and trekking enthusiasts. It is located inside Sanjay Gandhi National Park limits. Ideal for weekend relaxation and outdoor activities. The peaceful environment makes it popular among visitors. A great place to unwind during your Thane visit."
    },
    {
      title: "Suraj Water Park",
      description:
        "Suraj Water Park is a popular entertainment destination in Thane. It features exciting water slides and family-friendly attractions. Ideal for group outings and kids’ entertainment. Clean and well-maintained facilities attract tourists. Perfect for a fun-filled day trip. Easily reachable with comfortable cab travel."
    },
    {
      title: "Tikuji-ni-Wadi",
      description:
        "Tikuji-ni-Wadi is a combined amusement and water park in Thane. It is popular for family picnics and weekend trips. Offers rides, water slides, and resort facilities. Suitable for children and adults alike. Frequently visited by tourists from Pune and Mumbai. A great leisure spot during your Thane journey."
    },
    {
      title: "Masunda Lake (Talao Pali)",
      description:
        "Masunda Lake is located in the heart of Thane city. Visitors enjoy boating and lakeside relaxation. Surrounded by temples and eateries, it offers cultural charm. Evening views are especially beautiful. Popular among families and tourists. Ideal sightseeing destination in Thane."
    },
    {
      title: "Korum Mall",
      description:
        "Korum Mall is a major shopping and entertainment hub in Thane. It offers branded stores, restaurants, and multiplex cinema. Suitable for shopping lovers and families. Air-conditioned comfort makes it perfect for relaxed visits. Popular among travelers and locals alike. A convenient stop during your Thane cab trip."
    },
    {
      title: "Viviana Mall",
      description:
        "Viviana Mall is one of the largest malls in Thane. It features shopping outlets, fine dining, and entertainment zones. Ideal for leisure time after travel. Well-maintained and centrally located. Popular among visitors for premium shopping experience. Easily accessible with Lotus Cab."
    },
    {
      title: "Sanjay Gandhi National Park",
      description:
        "Located near Thane, this national park offers greenery and wildlife exploration. Perfect for nature lovers and photography enthusiasts. Trekking and cycling activities available. Peaceful environment away from city chaos. Frequently visited by tourists. A refreshing addition to your Thane trip."
    }
  ],

  services: [
    {
      name: "Pune to Thane Cab",
      description:
        "Book Pune to Thane cab with Lotus Cab for safe and comfortable intercity travel. Choose from sedan and SUV options based on your needs. Transparent pricing with no hidden charges provided. Professional drivers ensure smooth highway travel. One-way and round-trip options available. 24/7 booking support ensures convenience."
    },
    {
      name: "Pune to Thane Taxi Service",
      description:
        "Reliable Pune to Thane taxi service with punctual pickup from any location in Pune. Clean and well-maintained vehicles available. Experienced drivers ensure safety on the expressway route. Transparent billing structure maintained. Suitable for business and personal trips. Comfortable long-distance travel guaranteed."
    },
    {
      name: "Pune to Thane One Way Cab",
      description:
        "Affordable one-way cab service from Pune to Thane. Pay only for single-side distance with clear pricing. Ideal for drop service and relocation travel. Timely pickup and professional chauffeur provided. Comfortable sedan and SUV options available. Hassle-free booking process ensured."
    },
    {
      name: "Pune to Thane Round Trip Taxi",
      description:
        "Flexible round-trip taxi service for Pune to Thane route. Suitable for same-day return or extended stay. Transparent fare structure with return scheduling flexibility. Comfortable and spacious vehicles provided. Ideal for corporate meetings and family visits. Smooth and reliable service guaranteed."
    },
    {
      name: "Affordable Pune to Thane Cab",
      description:
        "Budget-friendly Pune to Thane cab service without compromising quality. Competitive per-km rates available. Clean vehicles and courteous drivers ensured. Suitable for daily travel needs. Transparent pricing policy followed. Reliable service for stress-free journey."
    },
    {
      name: "Luxury Cab Pune to Thane",
      description:
        "Premium luxury cab service for Pune to Thane travel. High-end vehicles available for VIP and corporate needs. Spacious seating and superior comfort ensured. Professional and well-trained chauffeurs provided. Ideal for executive travel. Premium experience guaranteed."
    },
    {
      name: "SUV Taxi Pune to Thane",
      description:
        "Spacious SUV taxi options for group and family travel. Extra luggage capacity available. Comfortable seating for long-distance rides. Suitable for family trips and business travel. Smooth highway performance ensured. Safe and secure journey guaranteed."
    },
    {
      name: "Online Cab Booking Pune to Thane",
      description:
        "Easy online cab booking for Pune to Thane route. Instant confirmation and quick response provided. Secure payment options available. Flexible scheduling supported. Transparent billing policy maintained. 24/7 customer assistance ensured."
    }
  ],

  tableData: [
    ["Pune to Thane Cab", "Pune to Thane Taxi Service"],
    ["Pune to Thane One Way Cab", "Pune to Thane Round Trip Taxi"],
    ["Affordable Pune to Thane Cab", "Luxury Cab Pune to Thane"],
    ["SUV Taxi Pune to Thane", "Cheap Pune to Thane Taxi"],
    ["Online Cab Booking Pune to Thane", "Best Cab Service Pune to Thane"],
    ["Corporate Cab Pune to Thane", "Family Trip Taxi Pune to Thane"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Reliable Intercity Travel",
      WhyChoosedescription:
        "Lotus Cab provides dependable Pune to Thane travel service with professional drivers and well-maintained vehicles ensuring safe highway journeys."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per-km fare structure with no hidden charges. Complete cost breakdown shared before booking confirmation."
    },
    {
      WhyChooseheading: "One-Way & Round Trip Options",
      WhyChoosedescription:
        "Flexible one-way drop and round-trip travel plans available to match your schedule and budget."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription:
        "Experienced chauffeurs familiar with expressway routes ensure safe and punctual travel."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Clean, sanitized, and regularly serviced sedan and SUV vehicles for comfortable long-distance travel."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer assistance for booking, fare queries, and travel coordination."
    },
    {
      WhyChooseheading: "Corporate Travel Friendly",
      WhyChoosedescription:
        "Suitable for business meetings and official trips with punctual service and professional approach."
    },
    {
      WhyChooseheading: "Family & Group Comfort",
      WhyChoosedescription:
        "Spacious vehicles available for family trips ensuring comfortable and safe journey."
    }
  ]
};

const faqData = [
  { question: "How much time does Pune to Thane cab take?", answer: "The journey typically takes around 3 to 4 hours depending on traffic conditions and route selection." },
  { question: "Do you provide one-way Pune to Thane taxi?", answer: "Yes, one-way drop service is available where you pay only for the single-side distance." },
  { question: "Are toll charges included?", answer: "Toll and parking charges are usually billed separately and clearly mentioned before booking." },
  { question: "Can I book SUV for family travel?", answer: "Yes, SUV options are available for family and group travel with extra luggage space." },
  { question: "Is night travel available?", answer: "Yes, 24/7 cab service is available including late-night and early morning trips." },
  { question: "Do you provide round-trip option?", answer: "Yes, flexible round-trip service is available with return scheduling support." },
  { question: "Are drivers experienced for expressway travel?", answer: "Yes, our drivers are well-trained and experienced in highway driving." },
  { question: "Is online booking available?", answer: "Yes, online booking with instant confirmation is available." },
  { question: "Are vehicles sanitized?", answer: "Yes, vehicles are cleaned and sanitized before every trip." },
  { question: "Do you provide corporate cab service?", answer: "Yes, corporate and executive travel services are available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Booked Pune to Thane cab with Lotus Cab. The driver was punctual and the journey was smooth via expressway. Transparent pricing and comfortable ride made it excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Shah",
    feedback:
      "Our family trip from Pune to Thane was very comfortable. The SUV was spacious and clean. Highly satisfied with service quality.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rohit Mehta",
    feedback:
      "Corporate travel to Thane was handled professionally. On-time pickup and fair pricing impressed me. Will book again.",
    rating: 5
  }
];



























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Thane Cab",
  "image": "https://lotuscab.com/assets/images/pune-to-thane-cab.jpg", 
  "description": "Lotus Cab offers Pune to Thane cabs with affordable one way and round trip taxi services. Book sedan, SUV, and luxury cabs for corporate travel, family trips, and comfortable outstation journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3399",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-thane-cab"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Thane Cab | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Thane cabs with Lotus Cab. Affordable one way & round trip taxi for corporate, family & luxury travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Thane Cab, Pune to Thane Taxi Service, Pune to Thane One Way Cab, Pune to Thane Round Trip Taxi, Affordable Pune to Thane Cab, Luxury Cab Pune to Thane, SUV Taxi Pune to Thane, Cheap Pune to Thane Taxi, Online Cab Booking Pune to Thane, Best Cab Service Pune to Thane, Corporate Cab Pune to Thane, Family Trip Taxi Pune to Thane" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetothanecab;